import { createSelector } from 'reselect'
import {
  selectIsNewCardDashboardEnabled,
  selectIsNewCardDashboardReady,
} from '~/store/flippers/selectors'
import {
  selectIsCardsDashboardEnabled,
  selectIsCardsDashboardReady,
} from '~/store/userInfo/selectors'

// TODO(sangnv-ptit): move from ProfileConfiguration (STRAITSX-27894)
export const selectShouldShowNewCardDashboard = createSelector(
  [selectIsCardsDashboardEnabled, selectIsNewCardDashboardEnabled],
  (configEnabled, flipperEnabled) => configEnabled && flipperEnabled
)

export const selectIsCardDashboardAccessReady = createSelector(
  [selectIsCardsDashboardReady, selectIsNewCardDashboardReady],
  (userInfoReady, flipperReady) => userInfoReady && flipperReady
)
